// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (string?: any) => {
	if (!string || typeof string !== 'string') {
		return false;
	}

	return /\S+@\S+/.test(string);
};
